<template>
    <static-content-page
        pageHeaderText="Property Search"
        pageSubHeaderText="Details returned for Property Ownership end-point."
        disableRegisterSection="true"
        documentationUrl="https://developers.afrigis.co.za/portfolio/property-ownership/"
        :cards="PropertiesCards"
        >
        <template #possibleUses>
            <p class="h4">Possible uses:</p>
            <ul>
                <li>Validate that a property is owned by a specific person.</li>
                <li>Determine the purchase price of properties in a certain area.</li>
            </ul>
        </template>
    </static-content-page>
</template>

<script>
import StaticContentPage from '@/components/StaticContentPage.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    StaticContentPage,
  },
  computed: {
    ...mapGetters({
      PropertiesCards: 'propertySearchStore/Properties',
    }),
  },
};
</script>
